import React from 'react';
// Components
import ManageExperienceTable from 'components/common/ManageExperienceTable';

const ManageAthleteProducts: React.FC = () => {
  return <ManageExperienceTable />;
};

export default ManageAthleteProducts;
